import React, {Component} from "react";

import Step1 from "./components/step1";
import Step2 from "./components/step2";
import Step3 from "./components/step3";

import {addToCart, clearCart} from '@/services/cart';
import {v4 as uuidV4} from 'uuid';
import history from "@/store/history";
import {ROUTESLIST} from "@/static/urls";
import {devFormDefaults} from "@/utils/devFormDefaults";
import {oneTimePlans} from "@/utils/constants";

export class DigitalLicenseWizard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            formData: devFormDefaults('digitalLicense'),
        };

        console.log("DigitalLicenseWizard props", this.state.formData);

        this.nextStep = this.nextStep.bind(this);
        this.prevStep = this.prevStep.bind(this);
    }

    handleFinalStepSubmit = (finalStepData) => {
        const allData = {...this.state.formData, ...finalStepData};
        const plan = oneTimePlans.find(plan => plan.id === 'digital-license');

        // Ensure only 1 item in the cart (remove all others)
        clearCart();
        addToCart({
            ...allData,
            ...plan,
            id: uuidV4(),
            product_type: "license",
        });

        this.setState({formData: allData});
        history.push(ROUTESLIST.CHECKOUT, {from: "digital-license"});
    };

    nextStep(newData) {
        this.setState((prev) => ({
            step: prev.step + 1,
            formData: {...prev.formData, ...newData},
        }));
    }

    prevStep() {
        this.setState((prev) => ({
            step: prev.step > 1 ? prev.step - 1 : 1,
        }));
    }

    renderStep() {
        const {step, formData} = this.state;
        // TODO: Add background images for each step

        switch (step) {
            case 1:
                return (
                    <Step1
                        onSubmit={this.nextStep}
                        initialValues={formData}
                    />
                );
            case 2:
                return (
                    <Step2
                        onSubmit={this.nextStep}
                        prevStep={this.prevStep}
                        initialValues={formData}
                    />
                );
            case 3:
                return (
                    <Step3
                        onSubmit={this.handleFinalStepSubmit}
                        prevStep={this.prevStep}
                        initialValues={formData}
                        isLastStep={true}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const bgImg = {}; // Placeholder for now
        const {step} = this.state;
        return (
            <main className="page">
                <section className="upload-form__sec" style={bgImg}>
                    <div className="content">
                        <div className="upload-form__top">
                            <h2 className="head-shadow">Digital License</h2>
                            <h3 className="head">Step {step} of 3: CLIENT INFO</h3>
                        </div>
                        <div className="form-step__body">
                            {this.renderStep()}
                        </div>
                    </div>
                </section>

            </main>
        );
    }
}

export default DigitalLicenseWizard;
